import { createFileRoute } from '@tanstack/react-router';
import type { User } from '@doorly/shared';
import { UserProfile } from '../features/users/UserProfile';
import { useApiQuery } from '../lib/api';

function UserProfilePage() {
  const { userId } = Route.useParams();
  const q = useApiQuery<User>(['user', userId], `/users/${userId}`);
  if (q.isLoading) return <p className="text-ink-mute text-body">Chargement…</p>;
  if (q.error) {
    return (
      <pre className="rounded-lg bg-red-50 border border-red-200 text-red-700 p-3 text-meta">
        {q.error instanceof Error ? q.error.message : String(q.error)}
      </pre>
    );
  }
  if (!q.data) return null;
  return <UserProfile user={q.data} />;
}

export const Route = createFileRoute('/users/$userId')({
  component: UserProfilePage,
});
